<style lang="stylus">
    .dialog-mask
        modal-mask()
        z-index 29
</style>

<template>
    <div class="dialog-mask" :class="{ noMask: isPC }" v-show="showDialogMask"></div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({})
    export default class DialogMask extends Vue {
        // 组件方法也可以直接声明为实例的方法
        get showDialogMask() {
            return this.$store.state.showDialogMask;
        }

        //生命周期
        mounted() {}

        created() {}
    }
</script>
